module.exports = __webpack_public_path__ + "static/media/pills.43d43337.svg";